let mapr = {};
let map;
let geocoder;
let imgLink;
let imgMapLink;
let popup;
let Popup;
let stores = [];
let latLangStores = [];
let markersArray = [];
let currentLocation;
let marker;
let storeNames = [];
let bounds;
let allStores = [];

document.addEventListener('DOMContentLoaded', function (event) {
  mapr.init();
});

mapr.init = () => {

  var list = $('.result-data');
  var ctr_ = 1;

  //add all the search results on stores object
  $.each(list, function (index, value) {
      if($(this).data('lat') !== "" && $(this).data('lng') !== ""){
        allStores.push({'address':$(this).data('address')+" "+$(this).data('postal')+" "+$(this).data('shortcode'), 'name': $(this).data('name'), 'shortcode' : $(this).data('shortcode'), 'lat' : $(this).data('lat'), 'lng' : $(this).data('lng')});
        $(this).show();
      }
      else{
        $(this).show();
      }
  });

  if (!document.getElementById('imgLink')) return
  if (!document.getElementById('imgMapLink')) return
  imgLink = document.getElementById('imgLink').dataset.img; //this is the icon image link for the map
  imgMapLink = document.getElementById('imgMapLink').dataset.img; //this is the icon image link for the map

  //initialize geocoder 
  geocoder = new google.maps.Geocoder();
  bounds = new google.maps.LatLngBounds();

  // set initial map coordinates
  mapper = new google.maps.Map(document.getElementById('mapid'), {
    center: {
      lat: -34.397,
      lng: 150.644
    },
    zoom: 10,
    mapTypeControl: false,
    fullscreenControl: false,
    streetViewControl: false
  });

   mapr.cardEvent();

  if (!document.getElementById('js-location-bar')) return
    document.getElementById('js-location-bar').addEventListener('click', () => {
      mapr.locationBar(allStores);
  });

  mapr.locationBar(allStores);
}


// get users current position
mapr.locationBar = (e) => {
  
  var in_area = [];
  var markers = [];

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      position => {
        locationLat = position.coords.latitude; //change to manipulate
        locationLong = position.coords.longitude; //change to manipulate
        /*locationLat = "48.856613";
        locationLong = "2.352222";*/
        var location = new google.maps.LatLng(locationLat, locationLong);
        $('#current-location').val(locationLat+"|"+locationLong);
        
        mapper.setCenter(new google.maps.LatLng(locationLat,locationLong));
        mapper.setZoom(10);

        marker = new google.maps.Marker({
          position: {
            lat: locationLat,
            lng: locationLong
            },
            map: mapper,
            icon: imgLink,
        });

        //:::     'M' is statute miles (default)
        //:::     'K' is kilometers
        //:::     'N' is nautical miles

        var distance = $('#distance').val();

        var unit = "K";

        $.each(e,function(index, value){
           if(value.lat !== "" && value.lng !== ""){
             var radlat1 = Math.PI * value.lat/180;
             var radlat2 = Math.PI * locationLat/180;
             var theta = value.lng-locationLong;
             var radtheta = Math.PI * theta/180;
             var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
             if (dist > 1) {
               dist = 1;
             }
             dist = Math.acos(dist);
             dist = dist * 180/Math.PI;
             dist = dist * 60 * 1.1515;
             if (unit=="K") { dist = dist * 1.609344 }
             if (unit=="N") { dist = dist * 0.8684 }

             //400 km for now 
             if(dist <= distance ){
                marker = new google.maps.Marker({
                position: {
                  lat: value.lat,
                  lng: value.lng
                  },
                  map: mapper,
                  icon: imgLink,
              });

                marker.addListener('click', function (data) {
                  let url = "https://www.google.com/maps/dir/?api=1&";
                  let mobile = "maps://www.google.com/maps/dir/?api=1&";                
                  let origin = "origin="+locationLat+","+locationLong;
                  let destination = "destination="+data.latLng.lat()+","+data.latLng.lng();
                  let travelmode = "&travelmode=driving";

                  let contentPopUp = "<div class='pop-up'><div class='icon-name'>"+value.name+"</div> <div class='icon-location'><img src=" + imgMapLink + ">"+value.shortcode+"</div> </div>";
                  
                  url = url+origin+"&"+destination;

                  if (window.innerWidth > 979) {
                    mapper.setCenter(data.latLng);

                    marker = new google.maps.Marker({
                        map: mapper,
                      });

                    mapper.setZoom(13);


                    if (!document.getElementById('content')) return

                    document.getElementById('content').innerHTML = contentPopUp;

                    if (!document.getElementById('contentLink')) return

                    Popup = createPopupClass();

                    $('#contentLink').attr('href',url);

                    popup = new Popup(
                      new google.maps.LatLng(data.latLng.lat(), data.latLng.lng()),
                      document.getElementById('contentLink'));
                    popup.setMap(mapper);

                  }
                  else{
                    marker = new google.maps.Marker({
                        map: mapper,
                        icon: imgLink,
                        position: {
                          lat: parseFloat(value.lat),
                          lng: parseFloat(value.lng)
                        }
                    });

                    mapper.setCenter(data.latLng);

                    mapper.setZoom(13);

                    marker.addListener('click',function(){
                      window.open(url, '_blank');
                    });
                  }
                  
                  
                });

              bounds.extend(marker.position);
              markersArray.push(marker);
             }
           }
        })     

        if(markersArray.length > 0){
          mapper.fitBounds(bounds);
          mapper.panToBounds(bounds);
        }                          
      },
      error => {
        alert(error.message);
      }
    );
  }
  else{
    //error message no geolocation
  }
}

// click event for making the card active
mapr.cardEvent = () => {
  let ele = document.getElementsByClassName('js-results-card');
  if (!ele) return
  for (let i = 0; i < ele.length; i++) {
    ele[i].id = 'js-results-card' + i;
    ele[i].addEventListener('click', function (e) {
      document.getElementById(this.id).classList.add('is-active');      
      mapr.checker(this.id, ele);      
      mapr.getAddress(this);
      if(window.innerWidth < 979) {
        mapr.scrollEvent();
      }
    });
  }
}

mapr.scrollEvent = () => {
  $('html, body').animate({
    scrollTop: $('#mapid').offset().top - 100,
  }, 500);
}

//checker for all the cards
mapr.checker = (e, ele) => {
  for (let i = 0; i < ele.length; i++) {
    if (ele[i].id != e) {
      ele[i].classList.remove('is-active');
    }
  }
}

mapr.converter = (e) => {
  var aa = 1;

  $.each(e,function(index, value){
     if(value.lat !== "" && value.lng !== ""){
        latLangStores.push({coor: [value.lat, value.lng], 'name' : value.name, 'shortcode' : value.shortcode });
     }
     else{
      //check by geocode?
     }
  });

  mapr.listStores(latLangStores);
}

mapr.listStores = (e) => {

  deleteMarkers();
  marker = new google.maps.Marker(null);

  $.each(e,function(index, value){

    marker = new google.maps.Marker({
      position: {
        lat: value.coor[0],
        lng: value.coor[1]
        },
        map: mapper,
        icon: imgLink,
    });

    bounds.extend(marker.position);    

    marker.addListener('click', function (data) {
      currentLocation = $('#current-location').val();

      if(currentLocation == ""){
        alert('User denied Geolocation');
      }

      currentLocation = currentLocation.split("|");

      let url = "https://www.google.com/maps/dir/?api=1&";
      let mobile = "maps://www.google.com/maps/dir/?api=1&";
      let origin = "origin=";
      let destination = "destination="+data.latLng.lat()+","+data.latLng.lng();
      let travelmode = "&travelmode=driving";

      let contentPopUp = "<div class='pop-up'><div class='icon-name'>"+value.name+"</div> <div class='icon-location'><img src=" + imgMapLink + ">"+value.shortcode+"</div> </div>";

      url = url+origin+currentLocation[0]+","+currentLocation[1]+"&"+destination;

      mapper.setCenter(data.latLng);

      marker = new google.maps.Marker({
          map: mapper,
        });

      mapper.setZoom(13);


      if (!document.getElementById('content')) return

      document.getElementById('content').innerHTML = contentPopUp;

      if (!document.getElementById('contentLink')) return

      Popup = createPopupClass();

      $('#contentLink').attr('href',url);

      popup = new Popup(
        new google.maps.LatLng(data.latLng.lat(), data.latLng.lng()),
        document.getElementById('contentLink'));
      popup.setMap(mapper);
    });

    mapper.fitBounds(bounds);
    mapper.panToBounds(bounds);
    markersArray.push(marker);

    stores = [];
    latLangStores = [];

  });
}

// parse address using geocoder
mapr.getAddress = (e) => {
  
  let address = e.dataset.address;
  let name = e.dataset.name;
  let zip = e.dataset.postal;
  let shortcode = e.dataset.shortcode;
  let url = "https://www.google.com/maps/dir/?api=1&";
  let mobile = "maps://www.google.com/maps/dir/?api=1&";
  let origin = "origin=";
  let destination = "destination=";
  let travelmode = "&travelmode=driving";
  let address_ = e.dataset.address;
  let lat = e.dataset.lat;
  let lng = e.dataset.lng;

  currentLocation = $('#current-location').val();

  if(currentLocation !== ""){
    currentLocation = currentLocation.split("|");
    destination_address = address+" "+zip+" "+shortcode.replace(/\s+/g, '+');

    url = url+origin+currentLocation[0]+","+currentLocation[1]+"&"+destination+destination_address;

    let contentPopUp = "<div class='pop-up'><div class='icon-name'> " + name +
      " </div> <div class='icon-location'><img src=" + imgMapLink + ">" + shortcode + "</div> </div>";          

    if (window.innerWidth > 979) {
      marker = new google.maps.Marker({          
        map: mapper,
      });


      if (!document.getElementById('content')) return

      document.getElementById('content').innerHTML = contentPopUp;

      if (!document.getElementById('contentLink')) return

      Popup = createPopupClass();

      $('#contentLink').attr('href',url);

      popup = new Popup(
        new google.maps.LatLng(lat, lng),
        document.getElementById('contentLink'));
      popup.setMap(mapper);


      mapper.setZoom(13);
      mapper.setCenter(new google.maps.LatLng(lat,lng));  
    }
    else{

      marker = new google.maps.Marker({
          map: mapper,
          icon: imgLink,
          position: {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
          }
      });

      mapper.setCenter(new google.maps.LatLng(parseFloat(lat),parseFloat(lng)));  

      mapper.setZoom(13);

      marker.addListener('click',function(){
        window.open(url, '_blank');
      });
    }
       
  }
  else{
    alert("User denied Geolocation");
  }
}


// this comes from google
/**
 * Returns the Popup class.
 *
 * Unfortunately, the Popup class can only be defined after
 * google.maps.OverlayView is defined, when the Maps API is loaded.
 * This function should be called by initmapper.
 */
function createPopupClass() {
  /**
   * A customized popup on the mapper.
   * @param {!google.maps.LatLng} position
   * @param {!Element} content The bubble div.
   * @constructor
   * @extends {google.maps.OverlayView}
   */
  function Popup(position, content) {
    this.position = position;

    content.classList.add('popup-bubble');

    // This zero-height div is positioned at the bottom of the bubble.
    var bubbleAnchor = document.createElement('div');
    bubbleAnchor.classList.add('popup-bubble-anchor');
    bubbleAnchor.appendChild(content);

    // This zero-height div is positioned at the bottom of the tip.
    this.containerDiv = document.createElement('div');
    this.containerDiv.classList.add('popup-container');
    this.containerDiv.appendChild(bubbleAnchor);

    // Optionally stop clicks, etc., from bubbling up to the mapper.
    google.maps.OverlayView.preventMapHitsAndGesturesFrom(this.containerDiv);
  }
  // ES5 magic to extend google.maps.OverlayView.
  Popup.prototype = Object.create(google.maps.OverlayView.prototype);

  /** Called when the popup is added to the mapper. */
  Popup.prototype.onAdd = function () {
    this.getPanes().floatPane.appendChild(this.containerDiv);
  };

  /** Called when the popup is removed from the mapper. */
  Popup.prototype.onRemove = function () {
    if (this.containerDiv.parentElement) {
      this.containerDiv.parentElement.removeChild(this.containerDiv);
    }
  };

  /** Called each frame when the popup needs to draw itself. */
  Popup.prototype.draw = function () {
    var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);

    // Hide the popup when it is far out of view.
    var display =
      Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ?
      'block' :
      'none';

    if (display === 'block') {
      this.containerDiv.style.left = divPosition.x + 'px';
      this.containerDiv.style.top = divPosition.y + 'px';
    }
    if (this.containerDiv.style.display !== display) {
      this.containerDiv.style.display = display;
    }
  };

  return Popup;
}

/*********on keyup search*************/
$('#js-input').on('keyup', function (data) {

    var input = $(this).val();
    var result_list = $('.result-data');
    var total = 0;
    var li = $('.sud-list-li');
    var address_checker = [];
    var _ctr = 1;

    if (input == "" || data.which == 13) {
      $('.sud-list').css("display", "none");
    } else {
      $('.sud-list').removeAttr('style');
    }

    var lang_all_results = $('#languages').data('all_results');
    var lang_results = $('#languages').data('results');

    stores = [];

    $.each(result_list, function (index, value) {
      var ctr = 0;
      var name = $(this).data('name');
      var address = $(this).data('address');
      var shortcode = $(this).data('shortcode');
      var zip = $(this).data('postal').toString();
      var telephone = $(this).data('telephone').toString();
      var lat = $(this).data('lat');
      var lng = $(this).data('lng');

      if (shortcode.toLowerCase().includes(input.toLowerCase())) {
        ctr++;
      }
      if (zip.toLowerCase().includes(input.toLowerCase())) {
        ctr++;
      }
      if (address.toLowerCase().includes(input.toLowerCase())) {
        ctr++;
      }

      if (ctr == 0) {

        $(this).hide();

      }else{
        $(this).show();
        total++;
        _ctr++;

        stores.push({'address':address+" "+zip+" "+shortcode, 'name': name, 'shortcode' : shortcode, 'lat' : lat, 'lng' : lng});

      }


    });

    $.each(li, function (index, value) {
      var shortcode = $(this).data('shortcode');
      var address = $(this).data('address');
      var zip = $(this).data('postal').toString();
      var ctr2 = 0;

      if (shortcode.toLowerCase().includes(input.toLowerCase())) {
        ctr2++;
      }
      if (zip.toLowerCase().includes(input.toLowerCase())) {
        ctr2++;
      }
      if (address.toLowerCase().includes(input.toLowerCase())) {
        ctr2++;
      }

      if (ctr2 == 0) {
        $(this).hide();
      } else {
        $(this).show();
      }
    });

    mapr.converter(stores);

    if(input == ""){
      $('.results').html('<span>'+lang_all_results+'</span> <span></span>');
    }
    else{
      $('.results').html('<span>' + total + ' '+lang_results+'</span> <span>, ' + input + '</span>');
    }
    $('#js-input-mobile').val(input);

});

$('#js-input-mobile').on('keyup', function (data) {

    var input = $(this).val();
    var result_list = $('.result-data');
    var total = 0;
    var li = $('.sud-list-li');
    var address_checker = [];
    var _ctr = 1;

    if (input == "" || data.which == 13) {
      $('.sud-list').css("display", "none");
    } else {
      $('.sud-list').removeAttr('style');
    }

    var lang_all_results = $('#languages').data('all_results');
    var lang_results = $('#languages').data('results');

    stores = [];

    $.each(result_list, function (index, value) {
      var ctr = 0;
      var name = $(this).data('name');
      var address = $(this).data('address');
      var shortcode = $(this).data('shortcode');
      var zip = $(this).data('postal').toString();
      var telephone = $(this).data('telephone').toString();
      var lat = $(this).data('lat');
      var lng = $(this).data('lng');

      if (shortcode.toLowerCase().includes(input.toLowerCase())) {
        ctr++;
      }
      if (zip.toLowerCase().includes(input.toLowerCase())) {
        ctr++;
      }
      if (address.toLowerCase().includes(input.toLowerCase())) {
        ctr++;
      }

      if (ctr == 0) {

        $(this).hide();

      }else{
        $(this).show();
        total++;
        _ctr++;

        stores.push({'address':address+" "+zip+" "+shortcode, 'name': name, 'shortcode' : shortcode, 'lat' : lat, 'lng' : lng});

      }

    });

    $.each(li, function (index, value) {
      var shortcode = $(this).data('shortcode');
      var address = $(this).data('address');
      var zip = $(this).data('postal').toString();
      var ctr2 = 0;

      if (shortcode.toLowerCase().includes(input.toLowerCase())) {
        ctr2++;
      }
      if (zip.toLowerCase().includes(input.toLowerCase())) {
        ctr2++;
      }
      if (address.toLowerCase().includes(input.toLowerCase())) {
        ctr2++;
      }

      if (ctr2 == 0) {
        $(this).hide();
      } else {
        $(this).show();
      }
    });

    mapr.converter(stores);

    if(input == ""){
      $('.results').html('<span>'+lang_all_results+'</span> <span></span>');
    }
    else{
      $('.results').html('<span>' + total + ' '+lang_results+'</span> <span>, ' + input + '</span>');
    }
    $('#js-input-mobile').val(input);

});

/****selected in dropdown ****/
$('.js-btn-sel').on('click', function (data) {
    var selected = $(this).parent('.sud-list-li');
    var cc = 0;

    var selected_storename = selected.data('storename');
    var result_list = $('.result-data');

    var lang_all_results = $('#languages').data('all_results');
    var lang_results = $('#languages').data('results');

    $.each(result_list, function (index, value) {
        if(selected_storename == $(this).data('name')){
            stores.push({'address':$(this).data('address')+" "+$(this).data('postal')+" "+$(this).data('shortcode'), 'name': $(this).data('name'), 'shortcode' : $(this).data('shortcode'), 'lat' : $(this).data('lat'), 'lng' : $(this).data('lng')});
          $(this).show();
          cc++;
        }
        else{
          $(this).hide();
        }
    });
    
    mapr.converter(stores);
    $('.results').html('<span>' + cc + ' '+lang_results+'</span> <span>, ' + selected_storename + '</span>');


    $('.sud-list').css("display", "none");
    $('#js-input-mobile').val(selected_storename);
    $('#js-input').val(selected_storename);
});
/****selected in dropdown end****/

function deleteMarkers() {
  
  for (var i = 0; i < markersArray.length; i++ ) {

    markersArray[i].setMap(null);
  }
  markersArray.length = 0;
  markersArray = [];
}




// WEBPACK FOOTER //
// ./scripts/components/map.js